<template>
    <el-card class="components-cardriver" :style="{width:width || '800px', 'min-height': '380px'}" >

      <div class="fl car-info">
        <p class="info-title">车辆信息</p>
        <div class="car-img-box">
          <t-img minHeight="150px" :host="IMG_SERVER" :src="data.carData.imageUrl" alt="车辆信息图" height="100%"></t-img>
        </div>
        <div class="car-info-box">
          <t-key-value label-width="30px"  label="车牌" v-if="data.carData.plateNumber">
            <t-plate width="10px" height="10px" :plateColor="data.carData.plateColor" :plateNumber="data.carData.plateNumber"></t-plate>
          </t-key-value>
          <t-key-value v-if="data.carData.carModel"  label-width="30px"  label="车型">{{data.carData.carModel}}</t-key-value>
          <t-key-value v-if="data.carData.axleCount" label-width="30px"  label="轴数" class="car-info-inline-left fl">{{data.carData.axleCount}}</t-key-value>
          <t-key-value v-if="data.carData.carWeight" label-width="30px"  label="车重" class="car-info-inline-right fl">{{data.carData.carWeight + '（吨）'}}</t-key-value>
          <t-key-value v-if="data.carData.wheelCount" label-width="30px"  label="胎数" class="car-info-inline-left fl">{{data.carData.wheelCount}}</t-key-value>
          <t-key-value v-if="data.carData.loadLimit" label-width="30px"  label="限载" class="car-info-inline-right fl">{{data.carData.loadLimit + '（吨）'}}</t-key-value>
          <t-key-value v-if="data.carData.passengerLimit" label-width="30px"  label="核载" class="car-info-inline-right fl">{{data.carData.passengerLimit + '（人）'}}</t-key-value>
        </div>
      </div>

      <div class="line"></div>

      <div class="fr driver-info">
        <p class="info-title">司机信息</p>
        <div class="driver-img-box">
          <t-img :host="IMG_SERVER" :src="data.driverData.faceImageUrl" alt="司机图" height="200px"></t-img>
        </div>
        <!--<div class="driver-info-box">
          <t-key-value  label="姓　　名">{{data.driverData.name}}</t-key-value>
          <t-key-value  label="性　　别">{{data.driverData.sex}}</t-key-value>
          <t-key-value  label="准驾车型">{{data.driverData.canDrivingMode}}</t-key-value>
          <t-key-value  label="驾照有效期">{{data.driverData.licenceTimeoutStart + '—' + data.driverData.licenceTimeoutEnd}}</t-key-value>
          <t-key-value  label="驾照证号">{{data.driverData.drivingLicence}}</t-key-value>
          <t-key-value  label="出生日期">{{data.driverData.birthday}}</t-key-value>
          <t-key-value  label="身份证号">{{data.driverData.identityNumber}}</t-key-value>
          <t-key-value  label="住　　址">{{data.driverData.address}}</t-key-value>
        </div>-->
      </div>
    </el-card>
</template>
<script>
  import {event, life} from './event.js'
  import {props, data, computed} from './model.js'
  import methods from './methods.js'
  import request from './request.js'
  export default {
    name: 't-car-driver-info',
    props,
    data () {
      return Mixins.init(this, {data, methods, request, event})
    },
    computed: {
      ...computed
    },
    watch: {

    },
    ...life
  }
</script>
<style lang="scss" scoped>
  @import "./carDriverInfo.theme";
  .components-cardriver{
    .el-card__body{
      position: relative;
      overflow: hidden;
    }
    .info-title{
      font-size:$cardriverinfo--font-size-title;
    }
    .car-info{
      width:50%;
      padding-right:$cardriverinfo--info-box-padding;
      box-sizing: border-box;
      .car-img-box{
        width:100%;
        margin:$cardriverinfo--info-margin auto 0;
        text-align: center;
        overflow: hidden;
      }
      .car-info-box{
        width:95%;
        overflow: hidden;
        clear: both;
        margin:$cardriverinfo--info-margin auto 0;
        .car-info-inline-left{
          width:40%;
        }
        .car-info-inline-right{
          width:60%;
        }
      }
    }

    .line{
      position: absolute;
      top: 10px;
      bottom: 10px;
      left:50%;
      border-right: 1px solid $cardriverinfo--line-color;
    }

    .driver-info{
      width:calc(50% - 1px);
      box-sizing: border-box;
      padding-left:$cardriverinfo--info-box-padding;

      .driver-img-box{
        width:100%;
        margin:$cardriverinfo--info-margin auto 0;
        text-align: center;
        overflow: hidden;
      }
      .driver-info-box{
        width:100%;
        overflow: hidden;
        clear: both;
        margin:$cardriverinfo--info-margin auto 0;
      }
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/carDriverInfo/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/carDriverInfo/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/carDriverInfo/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-carDriverInfo')
  export default {
    name: 'base-carDriverInfo', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-carDriverInfo': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>